import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-arrow-back",
  "use": "various-arrow-back-usage",
  "viewBox": "0 0 24 14",
  "content": "<symbol viewBox=\"0 0 24 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-arrow-back\"><path d=\"M14 8h10V6H14V0L0 7l14 7V8z\" fill=\"#e3000f\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol